import styled from 'styled-components';

export const Card = styled.div`
  background-color: ${({ theme }) => theme.palette.background.surface.main};
  padding: 4.8rem;
  border-radius: 2.4rem;
  margin-top: 10.4rem;
  max-width: 61.2rem;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    padding: 4.8rem 2.4rem;
    margin-top: 4.8rem;
  }
`;
